import {Container, Col, Row }from 'react-bootstrap';

import { CaretLeft, CaretRight, TelephoneInbound, Camera, CameraReels, Newspaper } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';



function Header(){
    return (
        <> 
            <Container fluid className="block-header-content color-bg-secondary">
                <Row className="border-bottom">
                    
                    <Col md={{ span: 2 }} className="px-1 py-0 text-start">
                        <Link to="/home" className='p-0 m-0 no-default-style-url'><div className="url-func">
                        <div className="py-0 my-0">
                            <img className="color-fill-primary branding-logo-small" src="/assets/logo-monochrome.svg" alt="Company Logo"  />
                        </div>
                        <div className="py-0 my-0">
                            <p className="pt-2 pb-0 my-0 color-font-primary font-size-small">Crafters & Curators of Story</p>
                        </div>
                        </div></Link>
                    </Col>
                    <Col xs={{span:12}} md={{ span: 6, offset: 4 }} className="py-0 text-end d-none d-sm-block">
                        <Row className="pb-2 justify-content-end">
                            <Col className="py-0 text-center color-font-primary col-auto"><a href="/projects" className="no-default-style-url url-style font-size-medium font-body"><CaretRight/> Project News <CaretLeft/></a></Col>
                            <Col className="py-0 text-center color-font-primary col-auto"><a href="/media" className="no-default-style-url url-style font-size-medium font-body"><CaretRight/> Media <CaretLeft/></a></Col>
                            <Col className="py-0 text-center color-font-primary col-auto"><a href="/contact" className="no-default-style-url url-style font-size-medium font-body"><CaretRight/> Contact <CaretLeft/></a></Col>
                        </Row>
                    </Col>
                    <Col xs={{span:12}} md={{ span: 4, offset: 6 }} className="py-0 text-end d-block d-sm-none">
                        <Row className="pb-2">
                            <Col className="py-0 text-center color-font-primary"><a href="/projects" className="no-default-style-url url-style font-size-small font-body"><Newspaper size={22}/></a></Col>
                            <Col className="py-0 text-center color-font-primary"><a href="/media" className="no-default-style-url url-style font-size-small font-body"><Camera size={22}/> <CameraReels size={22}/></a></Col>
                            <Col className="py-0 text-center color-font-primary"><a href="/contact" className="no-default-style-url url-style font-size-small font-body"><TelephoneInbound size={22}/></a></Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default Header;